import React from 'react';
import { Link, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";

import IconCart from './svg/IconCart';
import CartCounter from './CartCounter';
import More from '../common/More';

import useCartMenu from './hooks/useCartMenu';

import './Cart.css';

function CartMenu() {
  const storeRoute = useSelector(state => state.storeRoute)
  const isConnected = useSelector(state => state.isConnected)
  const storePopup = useSelector(state => state.storePopup)
  let match = useRouteMatch({ path: '/cart' });
  const setHistory = () => {
    if (isConnected) {
      storeRoute.goTo('/cart');
    } else {
      storePopup.cart();
    }
  }

  const refresh = useSelector(state => state.cartCounter)
  const { availableDrop, opacity, refDrop, showContextMenu } = useCartMenu(refresh);

  const onRightClick = (e) => {
    const el = document.getElementById(`more-ref-cart`);
    (el) && el.click();
  }

  return (
    <div className={`menu-left-container ${match && `selected`} `} onContextMenu={onRightClick}>
      {isConnected ? (
        <Link id={`link-ref-cart`} onClick={setHistory} style={{textDecoration: `none`}} to={isConnected ? '/cart' : '/'}>
          <div id={`ref-cart`} 
            className={`flexRow align top-menu-container cart ${match && `selected`} ${availableDrop && `droppable`}`} 
            ref={refDrop}
            style={{opacity, cursor: (availableDrop) ? `copy` : `pointer`}}
          >
            <IconCart size={28} />
            <div className={'flexRow space-between cart-menu-block'}>
              <span className={`type-medium fz14`} style={{marginLeft: 1}}>Cart</span>
              <CartCounter counter={refresh} />
            </div>
          </div>
        </Link>
      ) : (
        <div id={`ref-cart`} 
            className={`flexRow align top-menu-container cart ${match && `selected`} ${availableDrop && `droppable`}`} 
            ref={refDrop}
            style={{opacity, cursor: (availableDrop) ? `copy` : `pointer`}}
            onClick={setHistory}
          >
            <IconCart size={28} />
            <div className={'flexRow space-between cart-menu-block'}>
              <span className={`type-medium fz14`} style={{marginLeft: 1}}>Cart</span>
              <CartCounter counter={refresh} />
            </div>
          </div>
      )}
    { isConnected && <More id={`more-ref-cart`} size={24} className={`playlist-more top-menu-section`} onClick={showContextMenu} /> }
    </div>
  )
}

export default CartMenu;
